import { TableColumn } from '../../models';
import { IconButtonCellComponent, IconButtonCellProps } from './icon-button.component';

export class IconButtonColumn<I> extends TableColumn<I, IconButtonCellProps> {
  readonly component = IconButtonCellComponent;
}
